import {
  hasKey,
  isOneOf,
  isObject,
  isRecordOf,
  isString,
  isNumber,
  hasOptionalKey,
} from "../../core/utils";
import { sanitize } from "../parse";
import { DatasetConfig, FilterConfigType, YamlValue } from "./types";

const FILTER_TYPES: Array<FilterConfigType> = [
  "Radio_on",
  "Radio_off",
  "Standard",
];

const isYamlValue = (value: unknown): value is YamlValue =>
  isString(value) || isNumber(value);

export function isConfig(value: unknown): value is DatasetConfig {
  return (
    isObject(value) &&
    hasOptionalKey(value, "title", isYamlValue) &&
    hasOptionalKey(value, "blurb", isYamlValue) &&
    hasKey(value, "latitude", isYamlValue) &&
    hasKey(value, "longitude", isYamlValue) &&
    hasKey(value, "shortDescription", isYamlValue) &&
    hasKey(value, "filters", isRecordOf(isString, isOneOf(FILTER_TYPES)))
  );
}

export function sanitizeConfig(value: DatasetConfig): DatasetConfig<string> {
  return {
    title: value.title != null ? sanitize(`${value.title}`) : undefined,
    blurb: value.blurb != null ? sanitize(`${value.blurb}`) : undefined,
    latitude: sanitize(`${value.latitude}`),
    longitude: sanitize(`${value.longitude}`),
    shortDescription: sanitize(`${value.shortDescription}`),
    filters: Object.fromEntries(
      Object.entries(value.filters).map(([key, value]) => [
        sanitize(key),
        value,
      ])
    ),
  };
}
